// Tiny dependency-free SFX bus using the Web Audio API (no audio files).
// Synthesizes blips/whooshes/thuds on demand. Muted state persists.

let ctx = null;
let muted = false;
try {
  muted = localStorage.getItem('cybertech-sfx-muted') === '1';
} catch (e) {
  /* ignore */
}

const ac = () => {
  if (typeof window === 'undefined') return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

const tone = ({ freq = 440, dur = 0.1, type = 'sine', gain = 0.12, slideTo, delay = 0 }) => {
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime + delay;
  const osc = c.createOscillator();
  const g = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  if (slideTo) osc.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(gain, t0 + 0.008);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.02);
};

const noise = ({ dur = 0.18, gain = 0.12, lp = 1800 }) => {
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime;
  const buf = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
  const data = buf.getChannelData(0);
  for (let i = 0; i < data.length; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
  const src = c.createBufferSource();
  src.buffer = buf;
  const filter = c.createBiquadFilter();
  filter.type = 'lowpass';
  filter.frequency.setValueAtTime(lp, t0);
  const g = c.createGain();
  g.gain.setValueAtTime(gain, t0);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  src.connect(filter).connect(g).connect(c.destination);
  src.start(t0);
};

export const sfx = {
  unlock() {
    ac();
  },
  tick() {
    if (muted) return;
    tone({ freq: 1320, dur: 0.04, type: 'square', gain: 0.025 });
  },
  whoosh() {
    if (muted) return;
    noise({ dur: 0.22, gain: 0.08, lp: 2600 });
    tone({ freq: 520, slideTo: 1400, dur: 0.18, type: 'sawtooth', gain: 0.05 });
  },
  thud() {
    if (muted) return;
    tone({ freq: 150, slideTo: 48, dur: 0.22, type: 'sine', gain: 0.22 });
    noise({ dur: 0.12, gain: 0.14, lp: 900 });
  },
  victory() {
    if (muted) return;
    [523, 659, 784, 1047].forEach((f, i) => tone({ freq: f, dur: 0.5, type: 'triangle', gain: 0.1, delay: i * 0.09 }));
  },
  setMuted(m) {
    muted = m;
    try {
      localStorage.setItem('cybertech-sfx-muted', m ? '1' : '0');
    } catch (e) {
      /* ignore */
    }
  },
  isMuted() {
    return muted;
  },
};
